import { usePartyLicensesQuery } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { LoadingSkeleton } from "Components/Hunter/Merchants/NewRegistration/LoadingSkeleton";
import { MerchantNewRegistrationForm } from "Components/Hunter/Merchants/NewRegistration/MerchantNewRegistrationForm";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { Resources, useResource } from "Translations/Resources";
import { getAppUrl } from "Utils/UrlUtils";

export const MerchantNewRegistrationPage = () => {
  const user = useLoggedInUser();
  const { t } = useResource();

  const appUrl = getAppUrl();

  const {
    data: { items: licenses = [] } = {},
    isLoading: isLicenseLoading,
    isError: isLicenseError,
  } = usePartyLicensesQuery(user?.partyPublicID);

  if (isLicenseLoading) {
    return <LoadingSkeleton />;
  }

  if (isLicenseError || licenses.length === 0) {
    return <ErrorText>{t(Resources.Error.LicenseInfoFailed)}</ErrorText>;
  }

  return (
    <AuthenticatedLayout
      title={t(Resources.Hunter.Merchants.NewRegistration.Title)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("merchants"),
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <MerchantNewRegistrationForm licenses={licenses} />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default MerchantNewRegistrationPage;
